module.exports = __webpack_public_path__ + "static/media/21ECLAC11.3bb40747.jpg";